import { stateful, useState } from '@adornis/functional-lit/stateful.js';
import { html } from 'lit';
import { repeat } from 'lit/directives/repeat.js';
import { CardHeader } from '@adornis/components/client/CardHeader.js';

interface CardLoadingOptions {
  title?: string;
  elements?: number;
}

interface PageLoaderOptions {
  cardOptions?: CardLoadingOptions[];
}

export const CardLoader = stateful((options: CardLoadingOptions) => {
  const widthClasses = ['w-5/6', 'w-3/4', 'w-2/3', 'w-1/2', 'w-1/3'] as const;
  const total = options.elements ?? 5;
  const [elementSkeletons] = useState(
    (() => {
      const elements: { widthClass: string }[] = [];
      let widthIndex = 0;
      while (elements.length < total && widthIndex < widthClasses.length) {
        const count = Math.floor(Math.random() * 2) + 1;
        for (let i = 0; i < count && elements.length < total; i++) {
          elements.push({ widthClass: widthClasses[widthIndex] ?? 'w-1/3' });
        }
        widthIndex++;
      }
      return elements;
    })(),
  );

  return html`
    <div class="card card-body">
      ${CardHeader({
        title: options.title ?? '',
        divider: !!options.title,
      })}
      ${repeat(elementSkeletons, element => html` <div class="skeleton h-6 ${element.widthClass}"></div> `)}
    </div>
  `;
});

export const PageLoader = (options: PageLoaderOptions = {}) => {
  const cardOptions = options.cardOptions ?? [{}, {}, {}];

  return html`<div class="card-container">${repeat(cardOptions, cardOption => CardLoader(cardOption))}</div>`;
};
